import { get, del, put } from 'services/client'

const fetchNotifications = () => get('procurements/notifications')

const removeAll = () => del('procurements/notifications')

const readAll = () => put('procurements/notifications', { viewed: true })

const remove = id => del(`procurements/notifications/${id}`)

const mark = (id, viewed) => put(`procurements/notifications/${id}`, { viewed })

export { fetchNotifications, removeAll, readAll, remove, mark }
